import React, { useEffect, useMemo, useReducer, useRef, useState } from 'react';
import { thumbSwipeHandlers, thumbSwipeInitialState, thumbSwipeReducer } from '../../../../global/cnr/reducers/ThumbSwipeReducer';
import { svgElements, svgTypes } from '../../../../global/components/svg/svgElements';

const VolleyballCourt = () => {

  const [lines, setLines] = useState([]);

  const tss = useMemo(() => ({
    actionLineElements: [],
    actionLineColor: 'black',
    courtOuterColor: 'grey',
    statView: null,
    statGroupStatItem: null,
    statGroup: null,
    stateView: null,
    allowSwipeHold: null,
    handlers: null
  }), []);

  const imageStyle = { height: 540, width: 360 }
  // const _init_state = useMemo(() => ({ imageStyle, tss }), [imageStyle, tss, useSectors: true]);
  const _init_state = { imageStyle, tss, useSectors: true }
  const [thumbSwipe_state, thumbSwipe_dispatch] = useReducer(thumbSwipeReducer, _init_state, thumbSwipeInitialState);
  const thumbSwipe_handlers = thumbSwipeHandlers(thumbSwipe_dispatch, thumbSwipe_state)
  const { thumbTouch, currentSvgElements, currentElem, lastActionElement, done } = thumbSwipe_state
  const { handleTouchStart, handleTouchMove, handleTouchEnd } = thumbSwipe_handlers

  const _swipeDiv = useRef(null);

  useEffect(() => {
    console.log('thumbSwipe_state', thumbSwipe_state)
    console.log('_swipeDiv', _swipeDiv)
    thumbSwipe_handlers.handleDiv(_swipeDiv)
    thumbSwipe_handlers.handleSvgType(svgTypes.line)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      ref={_swipeDiv}
      onMouseDown={handleTouchStart}
      onMouseMove={handleTouchMove}
      onMouseUp={handleTouchEnd}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      style={{ width: imageStyle.width + 'px', height: imageStyle.height + 'px' }}
    >
      <svg
        // xmlns="http://www.w3.org/2000/svg"
        width={imageStyle.width}
        height={imageStyle.height}
        viewBox={"0 0 " + imageStyle.width + " " + imageStyle.height}
      >
        {/* Court background */}
        <rect x="0" y="0" width="260" height="500" fill="#F5DEB3" />

        {/* Boundary lines */}
        <rect x="10" y="10" width="240" height="480" fill="none" stroke="#000" stroke-width="2" />

        {/* Center line */}
        <line x1="10" y1="250" x2="250" y2="250" stroke="#000" stroke-width="2" />

        {/* Attack lines */}
        <line x1="10" y1="170" x2="250" y2="170" stroke="#000" stroke-width="2" />
        <line x1="10" y1="330" x2="250" y2="330" stroke="#000" stroke-width="2" />

        {/* Net */}
        <line x1="10" y1="250" x2="250" y2="250" stroke="#666" stroke-width="4" stroke-dasharray="4" />

        {/* Drawn lines */}
        {lines.map((line, index) => (
          <line
            key={index}
            x1={line.startX}
            y1={line.startY}
            x2={line.endX}
            y2={line.endY}
            stroke="red"
            strokeWidth="2"
          />
        ))}

        {/* Current line */}
        {currentElem && (
          <line
            x1={currentElem.sx}
            y1={currentElem.sy}
            x2={currentElem.ex}
            y2={currentElem.ey}
            stroke={currentElem.color}
            strokeWidth={currentElem.strokeWidth}
          />
        )}
      </svg>
    </div>

  );
};

export default VolleyballCourt;

